import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import {
	CompetenceSSIAD,
	CompetenceSESSAD,
	CompetenceSAAD
} from 'src/app/shared/enums/competence.enum';
import {
	PARAM_LABEL_BENEFICIAIRE,
	PARAM_LABEL_INTERVENANT,
	PARAM_LABEL_INTERVENTION
} from 'src/app/core/services/constant/constants.service';
import { CacheService } from 'src/app/core/services/cache/cache.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Address } from 'src/app/shared/models/address';
import { MissionRequest } from 'src/app/shared/models/mission/mission-request';
import { Employee } from 'src/app/shared/models/employee/employee';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { User } from 'src/app/shared/models/security/user';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-detail-user',
	templateUrl: './detail-user.component.html',
	styleUrls: ['./detail-user.component.scss']
})
export class DetailUserComponent implements OnInit {
	user: User;
	confirmDeleteModalRef: BsModalRef;
	detailFormationModalRef: BsModalRef;
	competences;
	isDeletable = true;

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;
	isAreaActive = false;

	labelUserCapitalized: string;
	labelIntervenantCapitalizedPluralized: string;
	labelIntervenantCapitalized: string;
	labelInterventionPluralizedCapitalized: string;

	isFormReadOnly = true;
	isAddressSelected: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: false };

	/**
	 * Index de pagination de la liste des formations d'un user
	 */
	currentPage: number;

	/**
	 * Attribut sur lequel trier
	 */
	sortType = 'date';

	/**
	 * Ordre de tri
	 */
	sortOrder: SortOrder = 'asc';

	pairMissionRqEmployee: {
		missionRequest: MissionRequest;
		employeeName: string;
	}[] = [];

	listEmployee: Employee[] = [];

	MAX_NAME_CHAR = 25;
	NAME_PATTERN =
		"^[0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+( [0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+)*$";
	form = new FormGroup({
		firstName: new FormControl('', [
			Validators.required,
			Validators.minLength(1),
			Validators.maxLength(this.MAX_NAME_CHAR),
			//Validators.pattern(this.NAME_PATTERN)
		]),
		lastName: new FormControl('', [
			Validators.required,
			Validators.minLength(1),
			Validators.maxLength(this.MAX_NAME_CHAR),
			//Validators.pattern(this.NAME_PATTERN)
		]),
		// address: new FormControl(new Address().label, [
		// 	Validators.maxLength(60)
		// ]),
		birthDate: new FormControl<Date>(null),
		phone: new FormControl('', Validators.pattern('0{1}[0-9]{9}')),
		active: new FormControl(),
		profile: new FormControl(),
		email: new FormControl('', [
			Validators.email]),
		username: new FormControl('', [
			Validators.minLength(1),
			Validators.maxLength(this.MAX_NAME_CHAR),
		])
	});

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private modalService: BsModalService,
		private facade: FacadeService,
		private cacheService: CacheService,
		private toastService: ToastService,
		private logger: LogService
	) {}

	ngOnInit(): void {
		this.cacheService.clearCache();
		this.labelUserCapitalized =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_BENEFICIAIRE
			);
		this.labelIntervenantCapitalizedPluralized =
			this.facade.dataStorageService.getLabelCapitalizedPluralized(
				PARAM_LABEL_INTERVENANT
			);
		this.labelIntervenantCapitalized =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_INTERVENANT
			);
		this.labelInterventionPluralizedCapitalized =
			this.facade.dataStorageService.getLabelCapitalizedPluralized(
				PARAM_LABEL_INTERVENTION
			);

		/**
		 * Récupère le paramètre de la route
		 */
		const id = +this.route.snapshot.paramMap.get('id');
		/**
		 * Appel le back pour récupérer l'user grâce à son id
		 */
		this.facade.userService.getUserBackById(id).subscribe({
			next: (user: User) => {
				this.user = user;
				if (this.user.address) {
					this.isAddressDefault.value = true;
				}
			},
			error: (err: ErrorResponse) => {
				this.facade.toastService.createHttpErrorToast(
					err.error.message ? err.error.message : '',
					err.status
				);
				this.goBack();
			}
		});
	}

	goBack(): void {
		this.router.navigate(['/gestion/users/list']);
	}

	goEdit(user: User): void {
		const link = ['/gestion/users/edit', user.id];
		this.router.navigate(link);
	}

	delete(user: User): void {
		if (this.isDeletable) {
			this.facade.userService
				.deleteUser(user.id)
				.subscribe({
					complete: () => {
						this.modalService.hide();
						this.goBack();
					},
					error: (err: ErrorResponse) => {
						this.isValidateButtonClicked.value = false;
						this.toastService.createHttpErrorToast(
							err.error.message,
							err.status
						);
					}
				});
		}
	}

	openModal(confirmDeleteTemplate: TemplateRef<any>): void {
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	editForm(): void {
		this.isFormReadOnly = false;
	}

	stopEditForm(): void {
		this.form.reset();

		if (
			this.user.address 
		) {
			this.isAddressDefault.value = true;
		}
		this.isAddressSelected.value = false;
		this.isFormReadOnly = true;
		this.isValidateButtonClicked.value = false;
	}

	onSubmit() {
		if (this.form.valid) {
			this.isValidateButtonClicked.value = true;
			console.log(this.user);
			this.facade.userService
				.updateUser(this.user)
				.subscribe({
					complete: () => {
						this.isValidateButtonClicked.value = false;
						this.reload();
					},
					error: (err: ErrorResponse) => {
						this.isValidateButtonClicked.value = false;
						this.toastService.createHttpErrorToast(
							err.error.message,
							err.status
						);
					}
				});
		}
	}

	reload() {
		const currentUrl = this.router.url;
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.onSameUrlNavigation = 'reload';
		this.router.navigate([currentUrl]);
	}
}
